import * as React from 'react';
import { connect } from 'react-redux';
import { DropdownItem, DropdownMenu, DropdownToggle, NavItem, NavLink, UncontrolledDropdown } from 'reactstrap';
import { Link, RouteComponentProps } from 'react-router-dom';
import './assets/css/NavMenu.css'
import { IAppState } from '../../../store';
import { IUserState } from '../../../store/reducers/userReducer';
import companyLogo from './assets/img/logo.png';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import IdentityService from '../../../services/membership/Identity.service';
import userService from '../../../services/membership/user.service';
import { enumPermissions, MuiMessageBarType } from '../../../enums';
import UtilityService from '../../../services/core/UtilityService';
import pageService, { IPageItem } from '../../../services/cms/page.service';
import { ComboboxItem } from '../../../common/UtilityService';
 
import { cacheable } from '../../../services/core/cache.Service';
const iconClass = mergeStyles({
    marginLeft: '2px'
});
type userProps = IUserState & RouteComponentProps;
interface NavMenuState {
    userName: string;
    IsAuthenticated: boolean;
    isOpen: boolean;
    hasRoleManagePermission: boolean;
    hasUserManagePermission: boolean;
    hasEventManagePermission: boolean;
    BaseInfoManagement: boolean;
    HasViewSurveyPermission: boolean;
    HasManagementPermission: boolean;
    isDataLoaded: boolean;
    changeBgByRefresh: boolean;
    PageItems: IPageItem[];
    ParentList: ComboboxItem[];
    showMessage: boolean;
    message: string;
    msgType: MuiMessageBarType;

}
let allpageItems: IPageItem[] = [];
class Header extends React.PureComponent<userProps, NavMenuState> {
    constructor(props) {
        super(props);
        this.state = {
            isDataLoaded: false,
            userName: "",
            IsAuthenticated: false,
            isOpen: false,
            hasRoleManagePermission: false,
            hasUserManagePermission: false,
            hasEventManagePermission: false,
            BaseInfoManagement: false,
            HasViewSurveyPermission: false,
            HasManagementPermission: false,
            PageItems: [],
            ParentList: [],
            showMessage: false,
            message: "",
            msgType: MuiMessageBarType.info,
            changeBgByRefresh: false
        };
    }
    public async componentDidMount() {
        this.CheckPermission();
        let chbgbr = localStorage.getItem("ChangeBgByRefresh");
        this.setState({ changeBgByRefresh: chbgbr !== null && chbgbr.toLowerCase() === "true" });
        await this.BindPages();
    }

    async CheckPermission() {
        let hasRMPerm = false;
        let hasUMPerm = false;
        let hasBaseInfoManagement = false;
        let hasTMPerm = false;

        var permissions = (await userService.GetPermissions()).map(x => x.Id);
        if (!UtilityService.isNullOrEmpty_Array(permissions)) {
            hasRMPerm = permissions.includes(enumPermissions.RoleManagement);
            hasUMPerm = permissions.includes(enumPermissions.UserManagement);
            hasTMPerm = permissions.includes(enumPermissions.EventManagement);
            hasBaseInfoManagement = permissions.includes(enumPermissions.BaseInfoManagement);

            this.setState(
                {

                    hasRoleManagePermission: hasRMPerm,
                    hasUserManagePermission: hasUMPerm,
                    hasEventManagePermission: hasTMPerm,
                    BaseInfoManagement: hasBaseInfoManagement,
                    isDataLoaded: true,
                    IsAuthenticated: true
                }
            );
        }
        else {
            this.setState(
                {

                    hasRoleManagePermission: false,
                    hasUserManagePermission: false,
                    hasEventManagePermission: false,
                    BaseInfoManagement: false,
                    isDataLoaded: true,

                }
            );
        }
        let un = await IdentityService.GetFullName();
        un = UtilityService.isNullOrEmpty(un) ? "کاربر گرامی" : un;

        let isAlive = await IdentityService.IsAuthenticated();
        this.setState({ IsAuthenticated: isAlive, userName: un });

    }
    handelSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        localStorage.setItem("ChangeBgByRefresh", event.target.checked ? "true" : "false");
        location.reload();
    };
    async BindPages() {
        try {
            allpageItems = [];
            this.setState({
                isDataLoaded: false,
                PageItems: []
            });
            let data: any = null;
            data = await cacheable(() => pageService.getAll(), "sitepages", null, 10)
            if (data !== null) {
                data.forEach(x => {
                    allpageItems.push({
                        Id: x.id, ParentId: x.parentId, Name: x.name, Title: x.title, PageOrder: x.pageOrder,
                        PageUrl: UtilityService.isNullOrEmpty(x.pageUrl) ? "/ShowPages?Id=" + x.id + "&Title=" + x.title : x.pageUrl
                        , Body: x.body, StartDate: x.startDate, EndDate: x.endDate
                    });
                    if (allpageItems.length > 1)
                        allpageItems = allpageItems.sort((a, b) => {
                            return a.PageOrder - b.PageOrder;
                        });
                });
                this.setState({
                    PageItems: allpageItems, ParentList: allpageItems.filter(x => x.ParentId === null).map(x => ({ id: x.Id, label: x.Name }))
                });
            }
            this.setState({
                isDataLoaded: true,
                // ParentList:[{id:0,label:""},...this.state.ParentList]
            });
        }

        catch (ex) {
            this.HandleException(ex);
        }

    }
    HandleException(ex) {
        const err = (ex as any).response;
        var msg = "";
        if (err) {

            if (err.data) {
                if (err.data.title) {
                    msg += err.data.title;
                    msg += "\n ";
                }
                if (err.data.detail)
                    msg += err.data.detail;
            }
            if (err.status === 500) {
                this.setState({
                    showMessage: true,
                    message: "درخواست با خطا مواجه گردید، لطفا دقایقی بعد مجددا تلاش فرمایید",
                    msgType: MuiMessageBarType.error,
                    isDataLoaded: true
                });
                return;
            }
            if (err.status === 400) {
                this.setState({
                    showMessage: true,
                    message: msg,
                    msgType: MuiMessageBarType.error,
                    isDataLoaded: true
                });
                return;
            }
            if (err.status === 404) {
                this.setState({
                    showMessage: true,
                    message: msg,
                    msgType: MuiMessageBarType.error,
                    isDataLoaded: true
                });
                return;
            }
            if (err.status === 403 || err.status === 401) {
                this.setState({
                    showMessage: true,
                    message: "شما مجاز به انجام این عمل نمی باشید",
                    msgType: MuiMessageBarType.error,
                    isDataLoaded: true
                });
                return;
            }
            if (err.message === "Network Error") {
                msg += "\n";
                msg += "لطفا از اتصال سیستم به شبکه اطمینان حاصل فرمایید"
            }
        }
        if (UtilityService.isNullOrEmpty(msg))
            msg = "درخواست با خطا مواجه گردید، لطفا دقایقی بعد مجددا تلاش فرمایید";

        this.setState({
            message: msg,
            showMessage: true,
            msgType: MuiMessageBarType.error,

            isDataLoaded: true
        });
        this.setState({
            showMessage: true,
            message: msg,
            msgType: MuiMessageBarType.error,

        });
    }
    public render() {
        //  const userJwt = useSelector((state: IAppState) => state.UserState?state.UserState.jwt:null);
        function getPageMenuItems(pa: IPageItem | any, allItems: IPageItem[]) {
            let pages = allItems.filter(x => x.ParentId == 0 || x.ParentId == null).map((item, i) => (
                getItems(allItems, item)
            ));

            return pages;
        }
        function getItems(allItems: IPageItem[], item: IPageItem) {

            return allItems.filter(x => x.ParentId == item.Id).length > 0 ?
                <UncontrolledDropdown nav inNavbar  >
                    <DropdownToggle nav caret >

                        {item.Title}

                    </DropdownToggle>
                    <DropdownMenu right>
                        {getChildsPageMenuItems(allItems.filter(x => x.ParentId == item.Id))}
                    </DropdownMenu>
                </UncontrolledDropdown>
                :
                <NavItem target='_blank' >
                    <NavLink tag={Link} key={item.Id} className="text-dark" to={item.PageUrl} target='_new' >
                        {item.Title}
                    </NavLink>
                </NavItem>

        }

        function getChildsPageMenuItems(childs: IPageItem[]) {
            return childs.map((item, i) => (
                <DropdownItem key={i}>
                    <NavItem key={i} target='_blank'>
                        <NavLink tag={Link} className="text-dark" key={item.Id} to={item.PageUrl} target='_blank'>
                            {item.Title}
                        </NavLink>
                    </NavItem>
                </DropdownItem  >
            ));
        }
        return (
        

 
  <header id="header" className="header fixed-top">
    <div className="container-fluid container-xl d-flex align-items-center justify-content-between">

      <a href="/home" className="logo d-flex align-items-center">
        <img src={ companyLogo} alt=""/>
        <span> شرکت  تجارت الکترونیک هوشمند تمدن
</span>
<span style={{ paddingRight:"5px",paddingTop:"3px"}}> 
(دانش بنیان)</span>
      </a>
      <nav id="navbar" className="navbar">
        <ul>
       
          <li><a className="nav-link scrollto" href="/about">درباره ما</a></li>
          <li><a className="nav-link scrollto" href="/products">محصولات</a>   </li>
        
       
          <li><a className="nav-link scrollto" href="/contact">ارتباط با ما</a></li>
 
          <li><a target='_blank' className="getstarted scrollto" href={require('./assets/iBgate_v1.pdf')} >دریافت کاتالوگ</a></li>
        </ul>
        <i className="bi bi-list mobile-nav-toggle"></i>
      </nav> 


    </div>
  </header> 

 


        )
    }
    private toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
}

export default connect((state: IAppState) => state.UserState)(Header as any);